'use strict';

var React = require('react');

var SvgViewportTallMajor = function SvgViewportTallMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m13.707 16.707-3 3a.999.999 0 0 1-1.414 0l-3-3a.997.997 0 0 1 .324-1.631 1 1 0 0 1 1.09.217l1.293 1.293v-4.586a1 1 0 0 1 2 0v4.586l1.293-1.293a1 1 0 0 1 1.414 1.414Zm0-13.414a1 1 0 0 1-1.414 1.414l-1.293-1.293v4.586a1 1 0 1 1-2 0v-4.586l-1.293 1.293a1.002 1.002 0 0 1-1.414 0 1 1 0 0 1 0-1.414l3-3a.997.997 0 0 1 1.414 0l3 3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 1a1.5 1.5 0 0 1 1.5 1.5v15a1.5 1.5 0 0 1-1.5 1.5h-4.5l2-2h2v-14h-2l-2-2h4.5Zm-16.5 16h2l2 2h-4.5a1.5 1.5 0 0 1-1.5-1.5v-15a1.5 1.5 0 0 1 1.5-1.5h4.5l-2 2h-2v14Z"
  }));
};

exports.SvgViewportTallMajor = SvgViewportTallMajor;
